import i18n from "../i18n/i18n";

export function localizedUrl(realUrl) {
  return i18n.language === "hi"
    ? `/api/translate?to=hi&src=${encodeURIComponent(realUrl)}`
    : realUrl;
}
